module.exports = __webpack_public_path__ + "static/media/beeicon.c97effa6.ico";